import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider, AuthProviderProps } from "react-oidc-context";
import App from "./App";
import config from "./config";
import "./index.css";
import { addLogger, consoleLogger } from "./logging";
import reportWebVitals from "./reportWebVitals";

addLogger(consoleLogger);

const oidcConfig: AuthProviderProps = {
  client_id: config.auth.clientId,
  authority: config.auth.authority,
  redirect_uri: window.location.origin + "/sign-in",
  scope: "profile email openid",
  onSigninCallback: () => {
    window.history.replaceState(
      {},
      document.title,
      localStorage.getItem("sign-in-pathname"),
    );
  },
  disablePKCE: false,
  client_authentication: "client_secret_post",
  extraQueryParams: {
    "audience": config.auth.audience
  }
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
